import { createSlice } from '@reduxjs/toolkit';

const AUTH_KEY  = 'eu_auth';
const RESET_KEY = 'eu_reset_required';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated:  !!localStorage.getItem(AUTH_KEY),
    username:         localStorage.getItem(AUTH_KEY) || null,
    resetRequired:    localStorage.getItem(RESET_KEY) === 'true',
  },
  reducers: {
    login(state, action) {
      // action.payload = { username, resetRequired }
      state.isAuthenticated = true;
      state.username        = action.payload.username;
      state.resetRequired   = action.payload.resetRequired;
      localStorage.setItem(AUTH_KEY,  action.payload.username);
      localStorage.setItem(RESET_KEY, String(action.payload.resetRequired));
    },
    logout(state) {
      state.isAuthenticated = false;
      state.username        = null;
      state.resetRequired   = false;
      localStorage.removeItem(AUTH_KEY);
      localStorage.removeItem(RESET_KEY);
    },
    clearResetRequired(state) {
      state.resetRequired = false;
      localStorage.setItem(RESET_KEY, 'false');
    },
  },
});

export const { login, logout, clearResetRequired } = authSlice.actions;
export default authSlice.reducer;
